import { cn } from '@/lib/cn'
import { formatFull, formatRelative } from '@/lib/time'
import { Tooltip } from './Tooltip'

type RelativeTimeProps = {
  value: string | null | undefined
  /** Text before the relative time, e.g. "updated". */
  prefix?: string
  className?: string
}

/** "updated 3 months ago" with the full date in a tooltip (and in <time datetime>). */
export function RelativeTime({ value, prefix, className }: RelativeTimeProps) {
  if (!value) return <span className={className}>{prefix ? `${prefix} date unknown` : '—'}</span>
  const text = prefix ? `${prefix} ${formatRelative(value)}` : formatRelative(value)
  return (
    <Tooltip content={formatFull(value)}>
      <time
        dateTime={value}
        tabIndex={0}
        aria-label={`${text} (${formatFull(value)})`}
        className={cn('cursor-default rounded-sm decoration-dotted underline-offset-2 hover:underline', className)}
      >
        {text}
      </time>
    </Tooltip>
  )
}
